/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class StripeCheckoutSessionCreateRequest {
    'priceId'?: string;
    'coupon'?: string;
    'successUrl': string;
    'cancelUrl': string;
    'clientReferenceId'?: string;
    'buyAsGiftcard'?: boolean;
    'buyerEmail'?: string;
    'giftcardPriceId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "priceId",
            "baseName": "priceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "coupon",
            "baseName": "coupon",
            "type": "string",
            "format": ""
        },
        {
            "name": "successUrl",
            "baseName": "successUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "cancelUrl",
            "baseName": "cancelUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "clientReferenceId",
            "baseName": "clientReferenceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "buyAsGiftcard",
            "baseName": "buyAsGiftcard",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "buyerEmail",
            "baseName": "buyerEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "giftcardPriceId",
            "baseName": "giftcardPriceId",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return StripeCheckoutSessionCreateRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

